export default __webpack_public_path__ + "static/media/doc-3.01edf942.jpg";